//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import md5 from 'js-md5';
import { fetchCode } from '@/api/user'; // import { validUsername } from '@/utils/validate'

export default {
  name: 'Login',
  data: function data() {
    var validateUsername = function validateUsername(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入用户名！'));
      } else {
        callback();
      }
    };

    var validatePassword = function validatePassword(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error('密码必须大于6位！'));
      } else {
        callback();
      }
    };

    var validateVcode = function validateVcode(rule, value, callback) {
      // 将用户输入数字转成字符串，同时转换成大写
      // value = value + ''
      // if (value.length > 4) {
      //   value = value.substring(0, 4)
      //   this.$set(this.loginForm, 'vcode', value)
      // }
      if (value.length !== 4) {
        callback(new Error('请输入验证码！'));
      } else {
        callback();
      }
    };

    return {
      loginForm: {
        username: '',
        password: '',
        validateCode: '',
        uuid: '',
        rememberMe: true
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }],
        validateCode: [{
          required: true,
          validator: validateVcode,
          triger: 'blur'
        }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      ccode: '',
      codesrc: ''
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created: function created() {
    this.getCode();
  },
  methods: {
    getCode: function getCode() {
      var _this = this;

      fetchCode({}).then(function (res) {
        if (res.data.code === 200) {
          _this.codesrc = res.data.data.image;
          _this.loginForm.uuid = res.data.data.uuid;
        }
      });
    },
    generatedCode: function generatedCode() {
      var random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      var code = '';

      for (var i = 0; i < 4; i++) {
        var index = Math.floor(Math.random() * 36);
        code += random[index];
      }

      this.ccode = code;
    },
    handleCode: function handleCode() {
      // 生成验证码
      // this.generatedCode()
      this.getCode();
    },
    checkCode: function checkCode() {
      // 判断验证码是否输入准确
      var vcode = this.loginForm.vcode;
      vcode = vcode.toUpperCase();
      var ccode = this.ccode;
      ccode = ccode.toUpperCase();

      if (vcode !== ccode) {
        this.$message.error('验证码有误，请重新输入！');
        this.$set(this.loginForm, 'vcode', '');
        this.$set(this.loginForm, 'password', '');
      } else {
        return 1;
      }
    },
    showPwd: function showPwd() {
      var _this2 = this;

      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }

      this.$nextTick(function () {
        _this2.$refs.password.focus();
      });
    },
    handleLogin: function handleLogin() {
      var _this3 = this;

      if (true) {
        var vcode = this.loginForm.validateCode.toUpperCase();
        this.$set(this.loginForm, 'validateCode', vcode);
        this.$refs.loginForm.validate(function (valid) {
          if (valid) {
            _this3.loading = true;
            var loginFormClone = JSON.parse(JSON.stringify(_this3.loginForm));
            loginFormClone.password = md5(loginFormClone.password);

            _this3.$store.dispatch('LoginByUsername', loginFormClone).then(function () {
              // console.log('登录页，跳转到dashboard')
              _this3.$router.push({
                path: '/dashboard'
              }); // 重置菜单


              _this3.$store.dispatch('ResetRouters', null).then(function () {
                // console.log('登录页，重置菜单')
                // 延时半秒刷新界面用于对付苹果端手机登录问题
                setTimeout(function () {
                  window.location.reload();
                }, 500);
              }).catch(function () {}); // 重置左侧侧边栏


              _this3.$store.dispatch('ChooseRouters', null).then(function () {}).catch(function () {
                console.log('重置左侧菜单失败');
              });

              _this3.loading = false;
            }).catch(function () {
              _this3.loading = false;

              _this3.$set(_this3.loginForm, 'validateCode', '');

              _this3.$set(_this3.loginForm, 'password', '');

              _this3.handleCode();
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }
};